<template>
  <div class="business">
    <van-nav-bar
      :title="$t('m.sm_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="business_con">
      <!-- <p class="business_con_tit">完成实名认证，保障资金安全 !</p> -->
      <p class="business_con_txt"></p>
      <div
        v-if="nextStepIndex == 1"
        style="background: rgb(255, 255, 255); border-radius: 10px; padding: 15px; margin: 30px auto 0px; width: 96%;"
      >
        <div
          style="display:flex;align-items:center;width: 100%;padding:0 20px;"
        >
          <div
            style="background:#F5F5F8;width:40px;border-radius:50%;color:#fff;height:40px;text-align:center;font-size:10px;"
          >
            <img
              style="width: 20px;height: 20px;margin:10px;"
              src="../../assets/images/icon2.png"
              alt=""
            />
          </div>
          <div
            style="background:linear-gradient(to right,#dfdfdf,#dfdfdf);height: 2px;flex:1;margin:0 15px;"
          ></div>
          <div
            style="background:#F5F5F8;width:40px;border-radius:50%;color:#fff;height:40px;text-align:center;font-size:10px;"
          >
            <img
              style="width: 20px;height: 20px;margin:10px;"
              src="../../assets/images/new/ren3.png"
              alt=""
            />
          </div>
        </div>
        <div
          style="display:flex;align-items:center;width: 100%;padding:0 0px;text-align:center;font-size:12px;color:var(--bg-color);margin-top:10px;justify-content: space-between;padding: 0 20px;"
        >
          <!-- <span style="width: 80px;">{{$t('m.sm_span2')}}</span> -->
          <span style="">{{ $t("m.sm_span3") }}</span>
          <span style="">{{ $t("m.sm_span4") }}</span>
        </div>
      </div>
      <div
        class="business_con_pic"
        style="margin-top:10px;"
        v-if="nextStepIndex == 1"
      >
        <div
          style="font-weight:bold;color:#666;font-size:16px;display:flex;align-items:center;"
        >
          <span
            style="width: 3px;height: 18px;margin-right:6px;background-color:var(--bg-color);"
          ></span>
          {{ $t("m.sm_span3") }}
        </div>
        <div class="form">
          <div class="item">
            <div class="label">{{ $t("m.sm_span01") }}</div>
            <div class="input" style="width: 100%;">
              <van-field
                style="border-bottom:1px solid #eee;flex:1;width: 100%;font-size:16px;font-weight:bold;padding-left:0;"
                v-model="form.name"
                label=""
                :placeholder="$t('m.sm_span02')"
                :border="false"
                label-class="label-class"
              />
            </div>
          </div>
          <div class="item" style="margin-top:20px;">
            <div class="label">{{ $t("m.sm_span03") }}</div>
            <div class="input" style="width: 100%;">
              <van-field
                style="border-bottom:1px solid #eee;flex:1;width: 100%;font-size:16px;font-weight:bold;padding-left:0;"
                v-model="form.idcard2"
                label=""
                :placeholder="$t('m.sm_span04')"
                :border="false"
                label-class="label-class"
                @blur="chaeckCard"
              />
            </div>
          </div>
        </div>
      </div>

      <div style="padding:0 20px;">
        <button class="business_but" @click="next()" v-if="nextStepIndex == 1">
          {{ $t("m.tijiao") }}
        </button>
      </div>
      <div
        style="background: rgb(255, 255, 255); border-radius: 10px; padding: 15px; margin: 30px auto 0px; width: 96%; display: flex;"
        v-if="nextStepIndex == 2"
      >
        <div style="border-radius:10px;background:#fff;width: 80%;">
          <div style="font-size:16px;font-weight:bold;margin-bottom:10px;">
            {{ $t("m.sm_span8") }}
          </div>
          <div
            style="display:flex;align-items:center;margin-bottom:0px;height: 30px;"
          >
            <span>{{ $t("m.sm_span01") }}：</span><span>{{ form.name }}</span>
          </div>
          <div style="display:flex;align-items:center;height: 30px;">
            <span>{{ $t("m.sm_span03") }}：</span
            ><span>{{ wayEncipher(form.idcard2) }}</span>
          </div>
        </div>
        <div style="width: 20%;">
          <img src="@/assets/images/bg/smrenz.png" />
        </div>
      </div>
    </div>
    <div style="height: 60px;"></div>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>
<script>
import { auth_add } from "@api/chat";
import { Dialog } from "vant";
import { getMyUserInfo } from "@api/user";
// import request from "@utils/request";
import axios from "axios";
export default {
  data: function() {
    return {
      shows: false,
      types: 1,
      active: "1",
      nextStepIndex: 1,
      stepList: [
        {
          id: 1,
          text: "实名认证",
          start: true,
          end: false
        },
        {
          id: 2,
          text: "确认信息",
          start: false,
          end: false
        },
        {
          id: 3,
          text: "提交完成",
          start: false,
          end: false
        }
      ],
      zhengImg: require("@/assets/images/licai/zheng.png"),
      beiImg: require("@/assets/images/licai/bei.png"),
      zhengshow: false,
      beishow: false,
      ossToken: {},
      imgCount: 0,
      form: {
        name: "",
        idcard: "",
        idcard2: ""
      },
      access_token: "",
      area: null
    };
  },

  created: function() {
    getMyUserInfo().then(res => {
      let userInfo = res.data.data;
      this.area = userInfo.area;
      if (userInfo.is_auth == 1) {
        this.nextStepIndex = 2;
        this.form.name = userInfo.realname;
        this.form.idcard2 = userInfo.idcard;
        this.form.idcard = userInfo.idcard;
      }
    });
    // request.get("/shop/sign/status", {}, { login: true });
  },

  methods: {
    wayEncipher(val) {
      if (!val) {
        return " ******** ";
      }
      return val.slice(0, 4) + " ******** " + val.slice(-4);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    fanhui: function() {
      this.$router.go(-1);
    },
    afterReadForZ(file) {
      let vm = this;
      console.log("正面");
      // vm.ossUpload(file, vm.ossToken, 0);
      vm.zhengImg = file.content;
      vm.zhengshow = true;
    },
    afterReadForB(file) {
      let vm = this;
      console.log("背面");
      // vm.ossUpload(file, vm.ossToken, 1);
      vm.beiImg = file.content;
      vm.beishow = true;
    },
    ossUpload(file) {
      axios
        .get("/baiduApi/oauth/2.0/token", {
          params: {
            client_id: "oDCFWizTIM746zrbxvlzXPfr",
            client_secret: "vGXeEkk8jpdA7qrW4uYoR5n1qipt1TDF",
            grant_type: "client_credentials"
          }
        })
        .then(response => {
          // handle success
          console.log("上传成功？", response);
          this.access_token = response.data.access_token;
          this.shangchuan(file);
        })
        .catch(error => {
          // handle error
          console.log("上传成功111？", error);
        });
    },
    shangchuan(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file.file);
      let formatdata = "";
      reader.onload = () => {
        formatdata = reader.result;
        formatdata = encodeURIComponent(formatdata);
        console.log("file 转 base64结果：" + formatdata);
        let url =
          "/baiduApi/rest/2.0/ocr/v1/idcard?access_token=" + this.access_token;
        axios
          .post(url, "id_card_side=front" + "&image=" + formatdata, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(res => {
            console.log("上传成功qqq？", res);
            // let ossImg = ossToken.host + "/" + ossToken.dir + file.file.name;
            // if (type == "0") {
            //   vm.zhengImg = ossImg;
            // }
            // if (type == "1") vm.beiImg = ossImg;

            // vm.imgCount++;
            // this.srcList.push(res.data.resultContent.filename);
          })
          .catch(res => {
            this.$dialog.error(res.response.data.msg);
          });
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    },
    imageToBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log("file 转 base64结果：" + reader.result);
        this.iconBase64 = reader.result;
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    },
    tab_line: function(type) {
      this.types = type;
    },
    next() {
      let vm = this;

      if (vm.nextStepIndex == 0) {
        console.log(vm.imgCount);
        vm.nextStepIndex = 1;
        vm.changeStepList(vm.nextStepIndex);
        return;
      }

      if (vm.nextStepIndex == 1) {
        this.shows = true;

        auth_add({ name: vm.form.name, idcard: vm.form.idcard2 })
          .then(res => {
            this.shows = false;
            vm.nextStepIndex = 2;
            vm.changeStepList(vm.nextStepIndex);
            if (this.area && this.area != "86") {
              Dialog.alert({
                title: "温馨提示",
                message: "提交以后请联系人工客服审核！",
                theme: "round-button"
              }).then(() => {
                this.$router.push({
                  path: "/customerService"
                });
              });
            }
            return;
          })
          .catch(err => {
            this.shows = false;
            console.log("回调", err);
            // this.$dialog.error(err.msg);
            this.$dialog.error(err.response.data.msg);
          });
      }
    },
    chaeckCard() {
      let vm = this;

      // vm.form.idcard=vm.form.idcard.substring(0,3)****vm.form.idcard.substring(val.length-3)
      vm.form.idcard = vm.form.idcard2;
      // vm.form.idcard2 = vm.form.idcard2.replace(/^(.{6})(?:\w+)(.{4})$/, "\$1********\$2")
    },
    changeStepList(index) {
      let vm = this;
      vm.stepList[index - 1].end = true;
      vm.stepList[index].start = true;
      if (index == vm.stepList.length - 1) {
        vm.stepList[index].end = true;
      }
    },
    checkIdentity(identity) {
      var reg = /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/;
      if (reg.test(identity)) {
        return true;
      } else {
        return false;
      }
    },
    gohome() {
      this.$router.replace({
        name: "Index"
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .business .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.business /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.business /deep/ .van-nav-bar__title {
  color: #fff;
}
.business /deep/ .van-icon {
  color: #fff;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}
.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.act-num {
  background: #1664fc !important;
  color: white !important;
}

.act-line {
  background: #1664fc !important;
}

.act-text {
  color: #797979 !important;
}
/deep/ .van-field__label {
  width: 0;
}
/deep/.van-uploader {
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translate(0px, -50%);
  opacity: 0;

  width: 100% !important;
  height: 80% !important;

  .van-uploader__wrapper {
    width: 100% !important;
    height: 100% !important;

    .van-uploader__upload {
      width: 100% !important;
      height: 100% !important;
    }
  }
}

.step {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin: 0 auto;

  .item {
    flex: 1;
    height: 60px;
    // display: flex;
    // align-items: center;
    position: relative;

    .num {
      width: 20px;
      height: 20px;
      background: #f0f0f2;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      color: #b2b2b2;
      font-size: 13px;
      font-weight: bold;
      position: relative;

      .text {
        position: absolute;
        left: 50%;

        bottom: -26px;
        transform: translate(-50%, 0px);
        font-size: 12px;
        font-weight: bold;
        color: #b2b2b2;
        width: auto;
        white-space: nowrap;
      }
    }

    .line {
      height: 3px;
      background: #f0f0f2;
      flex: 1;
    }

    .line2 {
      height: 3px;
      flex: 1;
      background: #f0f0f2;
    }
  }

  .item2 {
    width: 20px;
    height: 20px;
    background: #f0f0f2;
    border-radius: 50% !important;
    text-align: center;
    line-height: 20px;
    color: #b2b2b2;
    font-size: 13px;
    font-weight: bold;

    position: relative;

    .num {
      border-radius: 50%;
    }

    .text {
      position: absolute;
      left: 50%;

      bottom: -26px;
      transform: translate(-50%, 0px);
      font-size: 12px;
      font-weight: bold;
      color: #b2b2b2;
      width: auto;
      white-space: nowrap;
    }
  }
}

/deep/.form {
  margin-top: 20px;

  .item {
    width: 100%;
    align-items: center;
    padding-left: 10px;

    .label {
      width: 100%;
      color: #333;
      font-size: 15px;
      // font-weight: bold;
      text-align: justify;
      text-justify: inter-ideograph;
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      // display: flex;
      // align-items: center;
    }
  }
}

.rzjg {
  width: 100%;
  height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    // position: absolute;
    width: 100px;
    height: 100px;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%,-50%);
    object-fit: contain;
  }

  .text {
    font-size: 12px;
    color: #b2b2b2;
    // position: absolute;
    // width: 100px;
    // height: 100px;
    // top: 60%;
    // left: 50%;
    // transform: translate(-50%,-50%);
  }
}
</style>

<style lang="less" scoped>
.business {
}

.business_con_pic_tit {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.business_con_block {
  position: relative;
}

.business_con_block p {
  font-size: 14px;
  color: #666;
}

.business_con {
  padding: 10px 0px;
  margin-top: -46px;
  background-image: url(../../assets/images/bg/8.png);
  background-repeat: no-repeat;
  background-size: 100% 220px;
  padding-top: 60px;
}

.business_con_pic {
  margin-top: 0px;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
}

.business_con img {
  width: 100%;
  margin-top: 8px;
}

.business_con_tit {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  margin-top: 20px;
}

.business_con_txt {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.business_top {
  line-height: 45px;
  text-align: center;
  font-size: 18px;
}

.business_but {
  width: 100%;
  height: 50px;
  border-radius: 30px;
  text-align: center;
  margin-top: 30px;
  line-height: 50px;
  //background: linear-gradient(to right,#FF6241,#FF6241,#FF3738);
  background-color: var(--bg-color);
  color: #fff;
}
</style>
